export enum TypesRolesPermissions {
  ROLE_PRICING = "portal_comercial:pricing",
  ROLE_SALES_MARKETING_ACCESS = "portal_comercial:sales-marketing-access",
  ROLE_VIEW_ACCESSES = "portal_comercial:view-accesses",
  ROLE_TRIGGER_JOBS = "portal_comercial:trigger_jobs",
}
